__turbopack_context__.v({
  "dd": "Plaque-module__lMEG6W__dd",
  "dl": "Plaque-module__lMEG6W__dl",
  "dt": "Plaque-module__lMEG6W__dt",
  "pending": "Plaque-module__lMEG6W__pending",
  "root": "Plaque-module__lMEG6W__root",
});
